import { render, staticRenderFns } from "./EditGuidanceCategoryPage.vue?vue&type=template&id=d0f08028&"
import script from "./EditGuidanceCategoryPage.vue?vue&type=script&lang=js&"
export * from "./EditGuidanceCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports